document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('f-p-checkbox');
  const wrapper = document.querySelector('.f-p-add-to-cart-wrapper');
  const variantId = checkbox ? checkbox.getAttribute('data-variant-id') : null;

  function addProductToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      updateCart();
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function removeProductFromCart(variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const item = cart.items.find(item => item.variant_id == variantId);
        if (item) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Product removed from cart:', data);
            updateCart();
          })
          .catch(error => {
            console.error('Error removing product from cart:', error);
          });
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  function updateCart() {
    fetch('/cart')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const updatedCartItems = doc.querySelector('#main-cart-items');
        const currentCartItems = document.querySelector('#main-cart-items');
        if (currentCartItems && updatedCartItems) {
          currentCartItems.innerHTML = updatedCartItems.innerHTML;
        }

        const updatedSubtotal = doc.querySelector('.totals__wrapper');
        const currentSubtotal = document.querySelector('.totals__wrapper');
        if (currentSubtotal && updatedSubtotal) {
          currentSubtotal.innerHTML = updatedSubtotal.innerHTML;
        }

        // Check the checkbox state after updating the cart
        checkCartForFreightProtection();
        checkbox.classList.remove("uncheck");

        // Remove the 'active' class after the cart has been updated
        if (wrapper) {
          wrapper.classList.remove('active');
        }
      })
      .catch(error => {
        console.error('Error fetching updated cart:', error);
      });
  }

  function checkCartForFreightProtection() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const isInCart = cart.items.some(item => item.variant_id == variantId);

        if (checkbox) {
          checkbox.checked = isInCart;
        }

        return isInCart; // Return this value for further logic
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        return false; // Return false in case of error
      });
  }

  document.addEventListener('click', function(event) {
    const target = event.target;

    if (target.closest('[data-item-id]')) {
      const itemId = target.closest('[data-item-id]').getAttribute('data-item-id');
      console.log('Clicked element with data-item-id:', target);

      // Update checkbox state and other relevant actions
      checkbox.classList.add("uncheck");

      // Recheck the checkbox state based on current cart contents
      checkCartForFreightProtection();
    }
  });

  if (checkbox) {
    checkbox.addEventListener('change', function() {
      if (wrapper) {
        wrapper.classList.add('active');
      }

      // Check if the product is in the cart before adding or removing
      checkCartForFreightProtection().then(isInCart => {
        if (checkbox.checked) {
          if (isInCart) {
            // Product is already in the cart, remove it
            removeProductFromCart(variantId);
          } else {
            // Product is not in the cart, so add it
            addProductToCart(variantId);
          }
        } else {
          if (isInCart) {
            // Product is in the cart, so remove it
            removeProductFromCart(variantId);
          } else {
            // Product is not in the cart, add it again (if needed)
            addProductToCart(variantId);
          }
        }
      });
    });

    // Initial check on page load
    checkCartForFreightProtection();
  }
});
